<template>
	<div>
		<!-- Header -->
		<div class="flex wrap xs-12 min-height mb2">
			<div class="flex xs-12 md-6 xs-left xs-middle">
				<h2 class="fs7 lh125 fw7 c1 mr4">{{ $t("proposal") }}</h2>
			</div>
		</div>
		<div class="c2 cu2" @click="$emit('go:back')">{{ $t("back") }}</div>

		<!-- Proposal Root Fields -->
		<proposal-detail-credentials class="mt6" />

		<!-- Proposal Root Fields -->
		<proposal-rejection-info
			v-if="proposal.status === 'REJECTED'"
			class="mt6"
			:codes="rejectionCodes"
			:remarks="rejectionRemarks"
		/>

		<!-- Offers List -->
		<proposal-detail-offers
			class="mt6"
			@offer:click="$emit('offer:click', $event)"
		/>

		<!-- TODO: Proposal Premium Info -->

		<slot />
	</div>
</template>

<script>
import ProposalDetailOffers from "./ProposalDetailOffers"
import ProposalDetailCredentials from "./ProposalDetailCredentials"
import ProposalRejectionInfo from "./ProposalRejectionInfo"

export default {
	components: {
		ProposalDetailOffers,
		ProposalDetailCredentials,
		ProposalRejectionInfo
	},

	computed: {
		offers() {
			const proposal = this.$store.getters["caseManagement/proposal"]
			if (!proposal.basket) return []

			return proposal.basket.map(offer => ({
				...offer,
				productName: offer?.product?.name || "",
				formattedPrice: offer?.premium?.formattedPrice || ""
			}))
		},
		proposal() {
			return (
				this.$store.state.caseManagement.proposals.filter(p => {
					return p.id === this.$store.state.caseManagement.proposalId
				})[0] || {}
			)
		},
		rejectionCodes() {
			return this.proposal.rejectionCodes || []
		},
		rejectionRemarks() {
			return this.proposal.rejectionRemarks || ""
		}
	},
	mounted() {
		console.log(this.rejectionCodes)
		console.log(this.rejectionRemarks)
	}
}
</script>
